import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FloatingChatService {
  /** สั่งเปิด floating chat ไปที่ thread ID ที่ระบุ */
  readonly openThread$ = new Subject<string>();

  /** เปิด floating chat แล้วไปที่ thread */
  openThread(threadId: string): void {
    this.openThread$.next(threadId);
  }
}
